// 单文件引入方式

import FieldGroup from './ZuiFieldGroup.vue'

export default {
  install(Vue) {
    Vue.component('ZuiFieldGroup', FieldGroup)
  }
}

export { FieldGroup }
